import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Anatomy Next")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Admin")
const _hoisted_4 = { class: "app-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("search")
const _hoisted_7 = { class: "main" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
    /*#__PURE__*/_createElementVNode("span", null, "© 2021 - AnatomyNext")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_drawer_title = _resolveComponent("ui-drawer-title")!
  const _component_ui_drawer_subtitle = _resolveComponent("ui-drawer-subtitle")!
  const _component_ui_drawer_header = _resolveComponent("ui-drawer-header")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_ui_drawer_content = _resolveComponent("ui-drawer-content")!
  const _component_ui_drawer = _resolveComponent("ui-drawer")!
  const _component_app_bar = _resolveComponent("app-bar")!
  const _component_ui_grid_cell = _resolveComponent("ui-grid-cell")!
  const _component_ui_textfield_icon = _resolveComponent("ui-textfield-icon")!
  const _component_ui_textfield = _resolveComponent("ui-textfield")!
  const _component_ui_grid = _resolveComponent("ui-grid")!
  const _component_ui_drawer_app_content = _resolveComponent("ui-drawer-app-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_drawer, {
      type: "dismissible",
      "viewport-height": "",
      "nav-id": "menu"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ui_drawer_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ui_drawer_title, null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_ui_drawer_subtitle, null, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ui_drawer_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_navigation)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ui_drawer_app_content, { class: "content" }, {
      default: _withCtx(() => [
        _createVNode(_component_app_bar),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ui_grid, {
              class: "grid grid--header",
              margin: "16"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_grid_cell, {
                  class: "cell",
                  columns: "8",
                  nested: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_grid_cell, {
                      class: "cell",
                      columns: "12"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.getRouteData.title), 1),
                        _createElementVNode("i", null, _toDisplayString(_ctx.getRouteData.description), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ui_grid_cell, {
                  class: "cell",
                  columns: "4",
                  nested: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_grid_cell, {
                      class: "cell--search",
                      columns: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ui_textfield, {
                          outlined: "",
                          fullwidth: "",
                          modelValue: _ctx.searchString,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchString) = $event))
                        }, {
                          before: _withCtx(() => [
                            _createVNode(_component_ui_textfield_icon, null, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ui_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ui_grid_cell, {
                  columns: "12",
                  nested: ""
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _hoisted_8
        ])
      ]),
      _: 3
    })
  ]))
}